module.exports = __webpack_public_path__ + "assets/d336cc53783b4880e6758eeecc2000cd.mp3";